import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BehaviorSubject, Subscription } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { finalize, map, tap } from 'rxjs/operators';

import { WidgetConfiguration } from '../widget/config.widget.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
    DateRange,
    datesForDateRange,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PeriodType,
} from '../widget/date-range.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import {
    DualChartPerformanceComparison,
    DualChartPerformanceComparisonPillar,
} from './dual-chart-performance-comparison.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { MbnaComplianceWidgetComponent } from './mbna-compliance.widget.component';

@Component({
    selector: 'cmps-widget-mbna-dual-chart-performance-comparison',
    templateUrl:
        './mbna-dual-chart-performance-comparison.widget.component.html',
})
export class MbnaDualChartPerformanceComparisonWidgetComponent
    implements OnInit, OnDestroy
{
    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    dateRange: Date[];
    selectedDateRange: number;

    data: DualChartPerformanceComparison[];
    private _modal: NgbModalRef;

    // TODO revise
    private _showGoToDashboardButton: boolean;
    private _kpiIds: number[];
    dateRanges: DateRange[];
    populationType: number;

    constructor(
        private readonly _modalService: NgbModal,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this.hasPendingData = true;
        this._widgetService
            .dateRangesCompliance()
            .pipe(
                finalize(() => {
                    this.hasPendingData = false;
                }),
            )
            .subscribe((dateRanges) => {
                this.dateRanges = dateRanges;
                this.selectedDateRange = 0;
                this._widgetService.dateRangeCompliance.next(dateRanges[0]);
                this._sub = this._widgetService.dateRangeCompliance.subscribe(
                    (date) => {
                        if (date == null) {
                            return;
                        }
                        this.selectedDateRange = this.dateRanges.indexOf(date);
                        this.data = null;
                        this.dateRange = datesForDateRange(date);
                        this._service
                            .mbnaDualChartPerformanceComparison(
                                this.config.definitionId,
                                this.populationType,
                            )
                            // eslint-disable-next-line no-return-assign
                            .subscribe(
                                (data) => (this.data = data),
                                // eslint-disable-next-line no-return-assign
                                () => (this.hasPendingData = false),
                                // eslint-disable-next-line no-return-assign
                                () => (this.hasPendingData = false),
                            );
                    },
                );
            });
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    updateWidget(event: number) {
        this._widgetService.dateRangeCompliance.next(this.dateRanges[event]);
    }

    // TODO revise
    private _evalAttributes(): void {
        this._kpiIds = [];
        this.config.attributes
            .filter((attr) => attr.name)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
                if (attr.name.startsWith('kpiid')) {
                    if (attr.value == null || attr.value.length === 0) return;
                    this._kpiIds.push(parseInt(attr.value));
                }
                if (attr.name === 'populationtype') {
                    this.populationType = parseInt(attr.value);
                }
            });
    }

    onPieBarClick($event): void {
        this._showDetails($event.pillar);
    }

    private _showDetails(pillar: DualChartPerformanceComparisonPillar): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            windowClass:
                'cmps-widget-dual-chart-performance-comparison-modal-window',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: MbnaComplianceWidgetComponent,
            options: {
                hasDetails: this._showGoToDashboardButton,
                definitionId: this.config.definitionId,
                pillarIds: this._kpiIds,
                pillar,
                pillarIndex: this.data.findIndex(
                    (item) => item.piePillar === pillar,
                ),
                dateRanges: this.dateRanges,
                selectedDateRange: this.selectedDateRange,
                populationType: this.populationType,
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
